import { Base_URL } from "../helpers/constants";
import axios from "axios";

export default axios.create({
  baseURL: Base_URL,
});

export const axiosPrivate = axios.create({
  baseURL: Base_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
